<button
  class="flex items-center rounded-full p-2 text-black transition-colors duration-200 ease-in hover:bg-po-gray-75"
  type="button"
>
  <span class="sr-only">Close dialog</span>
  <aw-icon class="block w-3.5" icon="clear" />
</button>
